import React, { useEffect, useState } from 'react';

// Allows to watch for an html element width change.
// TODO: not performant => replace with @react-hook/resize-observer
// TODO: remove the Sentry ignore linked to the ResizeObserver
export const useResizeObserver = (ref: React.RefObject<HTMLDivElement>) => {
  const [observerValue, setObserverValue] = useState<number>();

  const updateResizeValue: ResizeObserverCallback = (entries) => {
    const contentBoxSize: number = entries[0].target.scrollWidth;
    if (contentBoxSize) {
      setObserverValue(contentBoxSize);
    }
  };

  useEffect(() => {
    if (ref.current) {
      const observer = new ResizeObserver(updateResizeValue);
      observer.observe(ref.current, {});
      return () => observer.disconnect();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateResizeValue]);

  return observerValue;
};
